/**
 * Centralized Spacing System
 *
 * Based on Bootstrap 3 padding/margin conventions from bootstrap-variables.less
 * Uses 8px base unit for modern systems, with Bootstrap 3 padding values preserved
 */

export const spacing = {
  // Base spacing unit (8px - standard for MUI)
  unit: 8,

  // Bootstrap 3 padding variants (from bootstrap-variables.less)
  bootstrap: {
    // @padding-base-vertical / @padding-base-horizontal
    base: {
      vertical: 2,
      horizontal: 4,
    },
    // @padding-large-vertical / @padding-large-horizontal
    large: {
      vertical: 10,
      horizontal: 16,
    },
    // @padding-small-vertical / @padding-small-horizontal
    small: {
      vertical: 5,
      horizontal: 10,
    },
    // @padding-xs-vertical / @padding-xs-horizontal
    xs: {
      vertical: 1,
      horizontal: 5,
    },
  },

  // MUI-style spacing scale (multiples of base unit)
  scale: {
    0: 0,
    1: 8,     // 1 * 8px
    2: 16,    // 2 * 8px
    3: 24,    // 3 * 8px
    4: 32,    // 4 * 8px
    5: 40,    // 5 * 8px
    6: 48,    // 6 * 8px
    7: 56,    // 7 * 8px
    8: 64,    // 8 * 8px
    9: 72,    // 9 * 8px
    10: 80,   // 10 * 8px
  },

  // Common component spacing
  components: {
    tableCellPadding: 8,            // @table-cell-padding
    tableCellPaddingCondensed: 5,   // @table-condensed-cell-padding
    modalInnerPadding: 20,          // @modal-inner-padding
    modalTitlePadding: 15,          // @modal-title-padding
    alertPadding: 15,               // @alert-padding
    panelBodyPadding: 15,           // @panel-body-padding (horizontal part)
    jumbotronPadding: 30,           // @jumbotron-padding
    breadcrumbPaddingVertical: 8,   // @breadcrumb-padding-vertical
    breadcrumbPaddingHorizontal: 15, // @breadcrumb-padding-horizontal
  },

  // Grid system spacing
  grid: {
    gutterWidth: 30,                // @grid-gutter-width
  },
} as const;

export type Spacing = typeof spacing;
